import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import Page from "webPage/Page";
import handleNavigation from "util/handleNavigation";
import handleAccordionBlocks from "blocks/handleAccordionBlocks";
import handleSubpageNavigation from "util/handleSubpageNavigation";
import handleScrollingSections from "util/handleScrollingSections";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    Page.init();

    handleNavigation();
    handleAccordionBlocks();
    handleSubpageNavigation();
    handleScrollingSections();
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
